import React from "react";
import { Link } from "react-router-dom";

function H2({ children }) {
  return <h2 className="text-xl font-medium text-zinc-100 mt-8 mb-3">{children}</h2>;
}
function P({ children }) {
  return <p className="text-sm text-zinc-300 leading-relaxed">{children}</p>;
}

export default function AGBPage() {
  return (
    <div className="mx-auto max-w-3xl space-y-6 px-2 py-2" data-testid="agb-page">
      <header className="space-y-2">
        <p className="text-xs uppercase tracking-[0.18em] text-zinc-500">Rechtliches</p>
        <h1 className="text-4xl font-semibold tracking-tight text-zinc-100 sm:text-5xl">
          Allgemeine Geschäftsbedingungen
        </h1>
        <p className="text-sm text-zinc-400">
          Für die Nutzung von DealAlert (<a className="text-emerald-400 hover:underline" href="https://dealalert.ai">https://dealalert.ai</a>).
          Stand: Juni 2026.
        </p>
      </header>

      <div className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-6 space-y-3">
        <H2>§ 1 Geltungsbereich & Vertragspartner</H2>
        <P>
          Anbieter ist Cloud Service International j.d.o.o., Zagreb, Kroatien („wir", „DealAlert"). Diese
          AGB gelten für jede Nutzung von DealAlert durch natürliche Personen, die das 18. Lebensjahr vollendet
          haben („Nutzer", „du"). Mit der Registrierung erklärst du dein Einverständnis mit diesen AGB und der{" "}
          <Link className="text-emerald-400 hover:underline" to="/datenschutz">Datenschutzerklärung</Link>.
        </P>
      </div>

      <div className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-6 space-y-3">
        <H2>§ 2 Was DealAlert ist — und was nicht</H2>
        <P>
          DealAlert ist ein <strong>Marktintelligenz-Tool</strong>: wir aggregieren Inserate aus öffentlichen
          Quellen (z. B. willhaben.at, ImmoScout24) und berechnen mit eigenen Algorithmen Markt-Signale,
          Preis-Schätzungen und Risiko-Hinweise.
        </P>
        <P>
          DealAlert ist <strong>KEINE</strong> Finanz-, Anlage-, Kauf- oder Rechtsberatung. Unsere Signale sind
          <strong>algorithmische Schätzungen</strong> — sie können falsch sein, durch fehlerhafte Quelldaten
          verzerrt sein oder den tatsächlichen Marktwert nicht treffen. Die KI-Antworten (Claude) sind
          generierte Texte und können Halluzinationen enthalten. Inserate können veraltet sein, vom Verkäufer
          zurückgezogen worden sein oder unvollständige Daten enthalten.
        </P>
        <P>
          <strong>Jede Kauf-, Verkaufs- oder Anlage-Entscheidung triffst du eigenverantwortlich.</strong> Wir
          empfehlen, jedes Inserat persönlich zu prüfen, den Verkäufer zu kontaktieren und bei großen Käufen
          unabhängige Beratung einzuholen.
        </P>
      </div>

      <div className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-6 space-y-3">
        <H2>§ 3 Account & Verifizierung</H2>
        <P>
          Die Registrierung erfordert E-Mail, Passwort, Vor- und Nachname sowie Zustimmung zu AGB &
          Datenschutzerklärung. Die E-Mail wird per Bestätigungs-Link verifiziert; bis zur Bestätigung sind
          bestimmte Funktionen eingeschränkt. Du verpflichtest dich, wahrheitsgemäße Angaben zu machen.
          Mehrfach-Accounts pro Person sind unzulässig.
        </P>
      </div>

      <div className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-6 space-y-3">
        <H2>§ 4 Trial, Abonnement & Preise</H2>
        <P>
          <strong>Trial:</strong> Nach Verifizierung deiner E-Mail erhältst du 24 Stunden kostenlosen Pro-Zugang
          („Trial"). Der Trial verlängert sich NICHT automatisch in ein kostenpflichtiges Abo — wenn du nach
          Ablauf weiternutzen möchtest, musst du aktiv buchen.
        </P>
        <P>
          <strong>Pro-Abonnement:</strong> 10,00 € pro Monat (inkl. ges. USt., sofern anwendbar), Laufzeit
          1 Monat, automatische Verlängerung. Kündbar jederzeit zum Monatsende über das Stripe Customer Portal
          („Abo verwalten"). Nach Kündigung bleibt Pro-Zugang bis zum Ende der bereits bezahlten Periode aktiv.
        </P>
        <P>
          <strong>Zahlungsabwicklung:</strong> ausschließlich über Stripe (SEPA, Kreditkarte, Apple/Google Pay).
          Wir speichern keine Karten-Daten — nur die Stripe-Kunden-ID und den Zahlungsstatus.
        </P>
        <P>
          <strong>Widerrufsrecht (§ 11 FAGG):</strong> Bei digitalen Dienstleistungen erlischt das Widerrufsrecht
          mit der ersten aktiven Nutzung des Pro-Zugangs, sofern du der sofortigen Ausführung ausdrücklich
          zustimmst. Dies geschieht implizit mit der ersten Pro-Funktions-Nutzung nach Buchung.
        </P>
      </div>

      <div className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-6 space-y-3">
        <H2>§ 5 Referral-Programm („Share & Earn")</H2>
        <P>
          Wenn jemand über deinen Empfehlungs-Link ein zahlendes Pro-Abo abschließt, erhältst du eine Provision
          von <strong>2,00 € pro Monat</strong> (L1) für jeden aktiv zahlenden geworbenen Nutzer. Wenn dein
          geworbener Nutzer selbst jemanden anwirbt, der zahlt, erhältst du zusätzlich <strong>1,00 € pro
          Monat</strong> (L2).
        </P>
        <P>
          <strong>Maximale Provision pro zahlendem Freund:</strong> 3,00 €/Monat (2 € L1 + 1 € L2).
        </P>
        <P>
          <strong>Voraussetzungen:</strong> Provisionen entstehen nur für tatsächlich gezahlte und bei Stripe
          erfolgreich verbuchte Abo-Rechnungen. Keine Provision für Trial-Phasen, Rückbuchungen, Charge-backs
          oder Fehlzahlungen. Stornierung führt zur automatischen Rückbuchung der Provision (status = reversed).
        </P>
        <P>
          <strong>Halte-Frist:</strong> 14 Tage. Provisionen sind erst nach Ablauf dieser Frist auszahlbar
          (entspricht Stripe-Refund-Window).
        </P>
        <P>
          <strong>Auszahlung:</strong> manuell per Banküberweisung ab 25,00 € auszahlbarem Guthaben. Du musst
          IBAN und Kontoinhaber im Share-&-Earn-Bereich eintragen. Auszahlung erfolgt innerhalb von 10 Werktagen
          nach Genehmigung.
        </P>
        <P>
          <strong>Anti-Abuse:</strong> Selbst-Referrals, gefälschte Accounts, automatisierte Anmeldungen und
          jede Form der missbräuchlichen Nutzung führen zur sofortigen Sperrung des Referral-Programms und
          Verfall sämtlicher offenen Provisionen — wir behalten uns weitere rechtliche Schritte vor.
        </P>
      </div>

      <div className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-6 space-y-3">
        <H2>§ 6 Pflichten des Nutzers</H2>
        <P>Du verpflichtest dich, DealAlert nicht zu nutzen, um:</P>
        <ul className="list-disc list-outside ml-5 text-sm text-zinc-300 space-y-1.5">
          <li>automatisiert Daten zu scrapen oder die API zu missbrauchen</li>
          <li>Sicherheitslücken auszunutzen oder Zugänge anderer Nutzer zu kompromittieren</li>
          <li>rechtswidrige Inhalte zu verbreiten oder andere Nutzer zu belästigen</li>
          <li>das Referral-System zu umgehen oder zu manipulieren</li>
        </ul>
      </div>

      <div className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-6 space-y-3">
        <H2>§ 7 Haftung & Haftungsbegrenzung</H2>
        <P>
          Wir haften unbeschränkt für Vorsatz und grobe Fahrlässigkeit, für Verletzungen von Leben, Körper und
          Gesundheit sowie nach zwingenden Bestimmungen des Produkthaftungs- und Konsumentenschutz-Rechts.
        </P>
        <P>
          Für leichte Fahrlässigkeit haften wir <strong>ausschließlich</strong> bei Verletzung wesentlicher
          Vertragspflichten (Kardinalpflichten) und nur in Höhe des vertragstypischen, vorhersehbaren
          Schadens, maximal jedoch in Höhe der in den letzten 12 Monaten vom Nutzer entrichteten Abo-Gebühren.
        </P>
        <P>
          <strong>Keine Haftung für:</strong> Marktsignale, Preis-Schätzungen, KI-Antworten, Aktualität,
          Vollständigkeit oder Richtigkeit von Inseraten aus Drittquellen. Kauf-Entscheidungen, die der
          Nutzer auf Basis unserer Daten trifft, liegen vollständig in seiner Verantwortung.
        </P>
      </div>

      <div className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-6 space-y-3">
        <H2>§ 8 Änderungen der AGB</H2>
        <P>
          Wir behalten uns vor, diese AGB anzupassen. Änderungen werden 30 Tage vorab per E-Mail angekündigt.
          Widerspricht der Nutzer nicht innerhalb dieser Frist, gelten die neuen Bedingungen als angenommen.
          Bei Widerspruch endet das Vertragsverhältnis zum nächsten regulären Kündigungstermin.
        </P>
      </div>

      <div className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-6 space-y-3">
        <H2>§ 9 Schlussbestimmungen</H2>
        <P>
          Gerichtsstand: Zagreb, Kroatien (sofern zulässig). Anwendbares Recht: kroatisches Recht unter Ausschluss
          des UN-Kaufrechts, vorrangig jedoch zwingendes EU-Verbraucherrecht des Wohnsitzlandes des Nutzers.
          Salvatorische Klausel: Sollte eine Bestimmung unwirksam sein, bleibt der Rest der AGB unberührt.
        </P>
      </div>

      <p className="text-xs text-zinc-500">
        Stand: Juni 2026. Bei Fragen:{" "}
        <a className="text-emerald-400 hover:underline" href="mailto:info@dealalert.ai">info@dealalert.ai</a>.
      </p>
    </div>
  );
}
